var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
function Flyout(_a) {
    var children = _a.children;
    return _jsx("div", __assign({ className: "px-2xs-gutter w-full h-full overflow-y-auto py-9" }, { children: children }));
}
export default Flyout;
